import React from 'react';
import { cn } from '../lib/utils';

/**
 * StatCards - Cards de totais no topo das listagens.
 *
 * @param {Array} cards - [{ key, label, value, Icon, tone }] (tone: classes de fundo e cor do ícone)
 * @param {string} className - Classes da grade (colunas por breakpoint)
 * @param {string} activeKey - Card selecionado
 * @param {Function} onSelect - (key) => void; torna os cards clicáveis
 */
function StatCards({ cards, className, activeKey, onSelect }) {
    return (
        <div className={cn('grid grid-cols-2 gap-4', className)}>
            {cards.map(({ key, label, value, Icon, tone, hint, hintClassName, onClick }) => {
                const handleClick = onClick || (onSelect ? () => onSelect(key) : undefined);
                return (
                    <button
                        key={key}
                        type="button"
                        onClick={handleClick}
                        disabled={!handleClick}
                        aria-pressed={activeKey === key}
                        className={cn(
                            'bg-white p-4 rounded-lg border text-left transition-colors disabled:cursor-default',
                            activeKey === key ? 'border-primary-600 ring-1 ring-primary-600' : 'border-gray-200',
                            handleClick && activeKey !== key && 'hover:border-gray-300 hover:bg-gray-50',
                        )}
                    >
                        <div className="flex items-center justify-between gap-2">
                            <div className="min-w-0">
                                <p className="text-sm text-gray-600 truncate">{label}</p>
                                <p className="text-2xl font-bold mt-1 text-gray-900 tabular-nums">{value}</p>
                                {hint && <p className={cn('text-xs mt-1 truncate', hintClassName || 'text-gray-500')}>{hint}</p>}
                            </div>
                            <div className={cn('w-12 h-12 shrink-0 rounded-lg flex items-center justify-center', tone)}>
                                <Icon className="w-6 h-6" />
                            </div>
                        </div>
                    </button>
                );
            })}
        </div>
    );
}

export default StatCards;
